import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from "react-router-dom"
import { Menu, X, Upload, Plus } from 'lucide-react';
import SideBar from './SideBar';
import Avatar from './Avatar';
import TopBanner from "./TopBanner";
import { WhatsNewButton } from './WhatsNew';
import OrganisationUsage from './OrganisationUsage';
import { UpgradePlanModalV2 } from './plans/UpgradePlanModal';
import CreateProjectModal from './CreateProjectModal';
const classNames = require('classnames');


export default function SideBarLayout({ children }) {
    const { id, org_id } = useParams();
    const history = useHistory();

    const [sidebarState, setSidebarState] = useState("hide");

    useEffect(() => {
        if (id) {
            localStorage.setItem("currentIntegration", id)
        }
    }, [id])

    return (
        <>
            <div className="app-container">

                <UpgradePlanModalV2 showCurrentPlan={true} />
                <CreateProjectModal />
                
                <div
                    className={classNames("sidebar", { hide: "hide" === sidebarState }, { show: "show" === sidebarState })}
                    onClick={e => {
                        if (window.innerWidth < 992 && e.target.closest('a, [data-close-sidebar]')) {
                            setSidebarState("hide");
                        }
                    }}
                >
                    <SideBar />
                </div>
                <div className={classNames("page", { push: "show" === sidebarState })}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <TopBanner inline />
                            </div>
                        </div>
                    </div>
                    <div className="top-nav d-flex align-items-center">
                        {/* Mobile menu toggle */}
                        <button
                            className="d-lg-none"
                            onClick={() => setSidebarState(sidebarState === "hide" ? "show" : "hide")}
                            style={{
                                width: 38, height: 38, borderRadius: 10, border: '1px solid #E2E8F0',
                                background: '#FFFFFF', cursor: 'pointer', display: 'flex',
                                alignItems: 'center', justifyContent: 'center', padding: 0,
                                marginRight: 8, flexShrink: 0, color: '#0F172A',
                            }}
                            aria-label="Toggle menu"
                        >
                            {sidebarState === "hide" ? <Menu size={18} /> : <X size={18} />}
                        </button>

                        <div className="flex-grow-1" />

                        {/* Right side items */}
                        <div className="top-nav-actions" style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                            <OrganisationUsage />

                            <WhatsNewButton />

                            <button
                                onClick={() => history.push(`/organisation/${org_id}/integration/${id}/content/new`)}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0,
                                    padding: '8px 14px', border: 'none', borderRadius: 9,
                                    background: '#0F172A', color: '#FFFFFF',
                                    fontSize: 13, fontWeight: 600, cursor: 'pointer',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                <Plus size={13} color="#FFFFFF" />
                                Create Audio
                            </button>

                            <button
                                onClick={() => history.push(`/organisation/${org_id}/integration/${id}/content-audio-articles?upload=1`)}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0,
                                    padding: '8px 14px', border: '1px solid #E2E8F0', borderRadius: 9,
                                    background: '#FFFFFF', color: '#334155',
                                    fontSize: 13, fontWeight: 600, cursor: 'pointer',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                <Upload size={13} color="#64748B" />
                                Upload
                            </button>

                            <Avatar />
                        </div>
                    </div>
                    <div className="content">
                        <div className="content-full">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}